// frontend/src/components/games/memory/MemoryBoard.tsx

import { MemoryCardModel } from '../../../hooks/games/useMemoryGame';
import { MemoryCard } from './MemoryCard';

interface MemoryBoardProps {
  cards: MemoryCardModel[];
  gridSize: number;
  onFlip: (card: MemoryCardModel) => void;
}

export function MemoryBoard({ cards, gridSize, onFlip }: MemoryBoardProps) {
  return (
    <div
      className="memory-board"
      style={{ gridTemplateColumns: `repeat(${gridSize}, 1fr)` }}
    >
      {cards.map((card) => (
        <MemoryCard key={card.id} card={card} onFlip={onFlip} />
      ))}
    </div>
  );
}
